import { render, staticRenderFns } from "./chooseReturnGoods.vue?vue&type=template&id=bc250ef6&scoped=true"
import script from "./chooseReturnGoods.vue?vue&type=script&lang=js"
export * from "./chooseReturnGoods.vue?vue&type=script&lang=js"
import style0 from "./chooseReturnGoods.vue?vue&type=style&index=0&id=bc250ef6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc250ef6",
  null
  
)

export default component.exports